import { ListProps, TextField, RichTextField } from 'react-admin';

import {
  BooleanField,
  ImageField,
  TextInput,
  Grid,
  GridList,
  Forbidden,
} from '@components';
import { useRbacList } from '@hooks';

export const JobList = (props: ListProps) => {
  const rbacList = useRbacList();

  if (!rbacList) {
    return <Forbidden />;
  }

  return (
    <GridList {...props}
      filters={Filters}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <Grid
        rowClick="edit"
        defaultColumns={'id title location employment isEnabled'.split(' ')}
      >
        <TextField source="id" label="ID" />
        <TextField source="title" label="Title" />
        <TextField source="location" label="Location" />
        <TextField source="employment" label="Employment" />
        <TextField source="department" label="Department" />
        <ImageField source="image" label="Image" />
        <RichTextField source="whatWeOffer" label="What We Offer" />
        <RichTextField source="aboutUs" label="About Us" />
        <RichTextField source="lookingFor" label="Looking For" />
        <RichTextField source="responsibleFor" label="Responsible For" />
        <RichTextField source="requiredSkills" label="Required Skills" />
        <RichTextField source="desiredSkills" label="Desired Skills" />
        <BooleanField source="isRemote" label="Remote" />
        <BooleanField source="isEnabled" label="Enabled" />
      </Grid>
    </GridList>
  );
};

const Filters = [
  <TextInput source="q" key="q" variant="outlined" label="Search" alwaysOn />,
];
